// extracted by mini-css-extract-plugin
export default {"backPage":"backPage_backPage__MUf52","arrow":"backPage_arrow__X4-av","arrowMoveBefore":"backPage_arrowMoveBefore__LyMuH","arrowMoveAfter":"backPage_arrowMoveAfter__ohnM4"};